import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../lib/apiClient';
import type { Division } from '../types';

const fetchUserDivisions = async (uuid: string): Promise<Division[]> => {
  const result = await apiClient().get(`api/admin/user/${uuid}/divisions`).json<Division[]>();
  return Array.isArray(result) ? result : [];
};

export const useUserDivisionsQuery = (uuid: string | undefined) => {
  return useQuery({
    queryKey: ['userDivisions', uuid],
    queryFn: () => fetchUserDivisions(uuid!),
    enabled: !!uuid,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
